module.exports = __webpack_public_path__ + "static/media/Winner2.e78bf02f.png";